import React, {useCallback} from 'react';
import * as _ from 'lodash';
import * as $ from 'jquery';
import 'foundation-sites';

/**
 * Component for showing share icons for Facebook, Twitter, and a copy link modal.
 *
 * @param url - The url to be shared.
 * @param sassPrefix - The sass prefix for styling.
 * @param showFacebook - Whether or not the Facebook share icon should be shown.
 * @param showTwitter - Whether or not the Twitter share icon should be shown.
 * @param showDirectLink - Whether or not the copy direct link modal option should be shown.
 */
export function ShareButtons({url, sassPrefix, showFacebook = true, showTwitter = true, showDirectLink = true}) {
    const encodedUrl = encodeURIComponent(url);
    const directLinkId = _.uniqueId('copyLinkModal-');

    const initializeFoundation = useCallback((ele) => {
        // Initialize foundation for the elements.
        $(ele).foundation();
        // Our version of Foundation has a bug where it generates duplicate overlays,
        // https://github.com/foundation/foundation-sites/pull/9166/files
        // Remove the empty ones that get added.
        $(document.body).ready(() => {
            $(document.body).find('.reveal-overlay:empty').remove();
        });
    }, []);

    return (
        <div ref={initializeFoundation}>
            <div className={`anvil-share anvil-share--${sassPrefix}`}>
                <div className="anvil-share__icons text-center medium-text-right">
                    {showFacebook === true && (
                        <a name="share_facebook"
                           target="_blank"
                           rel="noreferrer"
                           href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
                           data-click-tracker="Share"
                           data-click-tracker-arg-method="Facebook"
                           data-click-tracker-arg-url={url}
                        >
                            <i className="facebook-box-icon"></i>
                        </a>
                    )}
                    {showTwitter === true && (
                        <a name="share_twitter"
                           target="_blank"
                           rel="noreferrer"
                           href={`https://twitter.com/intent/tweet?text=${encodedUrl}`}
                           data-click-tracker="Share"
                           data-click-tracker-arg-method="Twitter"
                           data-click-tracker-arg-url={url}>
                            <i className="twitter-box-icon"></i>
                        </a>
                    )}
                    {showDirectLink === true && (
                        <a data-open={directLinkId}
                           data-click-tracker="Share"
                           data-click-tracker-arg-method="Link"
                           data-click-tracker-arg-url={url}>
                            <i className="link-variant-icon"></i>
                        </a>
                    )}
                </div>
            </div>
            {showDirectLink === true && (
                <div className="reveal anvil-reveal-container" id={directLinkId} data-reveal>
                    <div className="row expanded">
                        <div className="large-12 columns">
                            <div className={`row expanded collapse anvil-reveal anvil-reveal--${sassPrefix}`}>
                                <div className="columns anvil-reveal__text">
                                    <input name="share_link" type="text" id={`link-${directLinkId}`} defaultValue={url}
                                           readOnly={true}
                                           data-tooltip="true"
                                           data-disable-hover="true" data-click-open="false" data-fade-in-duration="250"
                                           data-tip-text="Copied" data-tooltip-class="anvil-reveal__tooltip"
                                           data-v-offset="16"/>
                                </div>
                                <div className="columns shrink">
                                    <button type="submit" className="anvil-reveal__button" id={`reveal-${directLinkId}`}
                                            data-copy="true"
                                            data-clipboard-action="copy"
                                            data-clipboard-target={`#link-${directLinkId}`}>COPY
                                    </button>
                                </div>
                                <div className="columns shrink anvil-reveal__close">
                                    {/* The data-close being false tells Foundation that we want to close a parent element */}
                                    <button data-close="false" aria-label="Close modal" type="button">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
